<template>
    <div>
        <div class="row">
            <div class="col">
                <h1>Edit Branch Info</h1>
            </div>

            <div class="col-auto">
                <locale-switcher @change="fetchAgain" />
            </div>
        </div>

        <form class="mt-4" @submit.prevent="saveBranchInfo">

            <div class="form-group">
                <label for="parent">
                    <small class="text-muted">BRANCH</small>
                </label>
                <select class="form-control" name="parent" v-model="branch_id" :disabled="loading">
                    <option v-for="branch in branches" :key="branch.id" :value="branch.id">
                        {{ branch.name }}
                    </option>
                </select>
            </div>

            <div class="form-group">
                <label>
                    <small class="text-muted">Phones</small>
                </label>
                <input type="text" class="form-control" :placeholder="Phones" v-model="phone" autofocus
                    :disabled="loading" />
            </div>

            <div class="form-group">
                <label>
                    <small class="text-muted">Details</small>
                </label>
                <input type="text" class="form-control" :placeholder="Address" v-model="address" autofocus
                    :disabled="loading" />
            </div>

            <button type="submit" class="btn btn-primary ld-ext-right mt-3" :disabled="loading"
                :class="{ running: loading }">
                {{ loading ? "saving..." : "Save" }}
                <div class="ld ld-ring ld-spin" />
            </button>
        </form>

        <div class="alert alert-danger mt-4" v-if="!loading && error">
            <p class="mb-0 text-center">
                {{ error }}
            </p>
        </div>
    </div>
</template>
  
  
<script>
import { getError } from "../../../helpers";
import FileInput from "../../FileInput";
import store from "../../../store";
import { mapGetters, mapState } from "vuex";
import LocaleSwitcher from '../../LocaleSwitcher';

export default {
    components: {
        "file-input": FileInput,
        'locale-switcher': LocaleSwitcher,
    },

    async beforeRouteEnter(to, from, next) {
        await store.dispatch("branches/fetchEverything");

        return store
            .dispatch("branchInfo/fetch", { id: to.params.id })
            .then((branchInfo) => {
                next((vm) => {
                    vm.branch_id = branchInfo.branch_id;
                    vm.phone = branchInfo.phone;
                    vm.address = branchInfo.address;
                });
            });
    },

    data() {
        return {
            branch_id: null,
            phone: "",
            address: "",
            loading: false,
            error: "",
        };
    },

    computed: {
        ...mapGetters({
            getBranchInfoById: "branchInfo/getById",
        }),
        branchInfo() {
            return this.getBranchInfoById(parseInt(this.$route.params.id));
        },

        ...mapState({
            branches: state => state.branches.branches,
        }),
    },

    methods: {
        saveBranchInfo() {
            this.loading = true;

            return this.$store
                .dispatch("branchInfo/update", {
                    id: this.$route.params.id,
                    branch_id: this.branch_id,
                    phone: this.phone,
                    address: this.address,
                })
                .then(() => {
                    this.$router.push({ name: "settings" });
                })
                .catch((e) => {
                    this.error = getError(e);
                    this.loading = false;
                });
        },

        fetchAgain({ oldValue }) {
            this.loading = true;

            this.$store
                .dispatch("branchInfo/update", {
                    id: this.$route.params.id,
                    branch_id: this.branch_id,
                    phone: this.phone,
                    address: this.address,
                })
                .then(async () => {
                    const branchInfo = await this.$store.dispatch("branchInfo/fetch", {
                        id: this.$route.params.id,
                    });
                    await store.dispatch("branches/fetchEverything");
                    this.branch_id = branchInfo.branch_id
                    this.phone = branchInfo.phone;
                    this.address = branchInfo.address;
                })
                .catch((e) => {
                    this.$store.dispatch("setContentLocale", oldValue);
                    this.error = getError(e);
                })
                .finally(() => {
                    this.loading = false;
                });
        },
    },


    meta: {
        title: "Create a Branch-info",

        meta: [{ property: "og:title", content: "Edit a Branch-info / Shayah" }],
    },
};
</script>
  